import React from "react";
import styles from "./TimelineHeader.module.css";
import { STATUS_COLOR } from "./timelineUtils";

export default function TimelineHeader({
  route,
  onPersonClick,
  collapsedMode,
  setCollapsedMode,
  movementMode,
  setMovementMode,
  sortMode,
  setSortMode,
  onReset,
  onFit,
  win,
}) {
  const receipts = route.receipts || [];
  const total = receipts.length || 1;
  const delivered = receipts.filter((r) => r.status === "Закрыта").length;
  const opened = receipts.filter((r) => r.status === "Открыта").length;
  const undelivered = receipts.filter((r) => r.status === "Не доставлено").length;

  const avgTravel = route.avg_travel_time ?? 32;
  const avgStop = route.avg_stop_time ?? 12;
  const totalTime = route.total_duration ?? 5.4;

  return (
    <div className={styles.header}>
      {/* === Левая часть: маршрут и команда === */}
      <div className={styles.left}>
        <h3>Маршрут №{route.route_number}</h3>
        {route.driver && (
          <button className={styles.link} onClick={() => onPersonClick?.(route.driver)}>
            {route.driver}
          </button>
        )}
        {[route.loader1, route.loader2].filter(Boolean).map((n, i) => (
          <button key={i} className={styles.link} onClick={() => onPersonClick?.(n)}>
            {i === 0 ? " • " : ", "}
            {n}
          </button>
        ))}
      </div>

      {/* === Центральная часть: фильтры === */}
      <div className={styles.controls}>
        <span className={styles.dim}>Движение:</span>
        <select
          className={styles.select}
          value={movementMode}
          onChange={(e) => setMovementMode(e.target.value)}
        >
          <option value="travel">в пути</option>
          <option value="stop">стоянки</option>
          <option value="both">всё</option>
        </select>

        <span className={styles.dim}>Сортировка:</span>
        <select
          className={styles.select}
          value={sortMode}
          onChange={(e) => setSortMode(e.target.value)}
        >
          <option value="movement">по движению</option>
          <option value="status">по статусу</option>
          <option value="scan">по сканам</option>
        </select>

        <button className={styles.smallBtn} onClick={onReset}>
          Сброс
        </button>
        <button className={styles.smallBtn} onClick={onFit}>
          Подогнать
        </button>

        <span className={styles.dim}>
          {win.start.toFixed(1)}–{win.end.toFixed(1)} ч
        </span>
      </div>

      {/* === Правая часть: метрики и статусы === */}
      <div className={styles.metrics}>
        <div className={styles.statGroup}>
          <div className={styles.stat}>
            <span className={styles.label}>в пути</span>
            <b>{avgTravel} м</b>
          </div>
          <div className={styles.stat}>
            <span className={styles.label}>стоянки</span>
            <b>{avgStop} м</b>
          </div>
          <div className={styles.stat}>
            <span className={styles.label}>итого</span>
            <b>{totalTime} ч</b>
          </div>
        </div>

        <div className={styles.statusGroup}>
          <div className={styles.progressBar}>
            <div style={{ width: `${(delivered / total) * 100}%`, background: STATUS_COLOR["Закрыта"] }} />
            <div style={{ width: `${(opened / total) * 100}%`, background: STATUS_COLOR["Открыта"] }} />
            <div style={{ width: `${(undelivered / total) * 100}%`, background: STATUS_COLOR["Не доставлено"] }} />
          </div>

          <div className={styles.legend}>
            <span style={{ color: STATUS_COLOR["Закрыта"] }}>✓ {delivered}</span>
            <span style={{ color: STATUS_COLOR["Открыта"] }}> • {opened}</span>
            <span style={{ color: STATUS_COLOR["Не доставлено"] }}> • {undelivered}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
